// Public links have one canonical destination. Legacy installations keep their
// own origin for API, service-worker and private-device storage compatibility.
const PUBLIC_ORIGIN='https://kelimo.forin.com.tr';
const LEGACY_ORIGIN='https://oyun.forin.com.tr';
const PUBLIC_HOST='kelimo.forin.com.tr';
const APP_ORIGINS=Object.freeze([PUBLIC_ORIGIN,LEGACY_ORIGIN]);
module.exports={PUBLIC_ORIGIN,LEGACY_ORIGIN,PUBLIC_HOST,APP_ORIGINS};
